import * as LucideIcons from 'lucide-vue-next';
import userCheckSvg from '@/assets/images/user-check.svg';
import percentSvg from '@/assets/images/percent.svg';

export const getIconComponent = (iconName: string) => {
  // needed for dynamic icon rendering
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (LucideIcons as any)[iconName] || null;
};

export const svgAssets: Record<string, string> = {
  UserCheck: userCheckSvg,
  Percent: percentSvg,
};
